<template>
	<span class="school" @click="toSchoolSecond">
		<el-image :src="schooldata.Logo">
			<template #error>
				<div class="image-slot">
					<el-icon>
						<Picture />
					</el-icon>
				</div>
			</template>
		</el-image>
		<span class="name">
			<span class="gby-font">{{schooldata.Name}}</span>
			<jieDuNumber v-if="schooldata.ID" class="jieDu" :key="schooldata.ID" :refID="schooldata.ID"
				:refType="schooldata.DicType" :num='schooldata.JieDuNum'></jieDuNumber>
			
			<!-- 后台不加院校比较 -->
			<compareIcon v-if="IsFront && isLogin" type="1" :refID="schooldata.ID" class="compare"></compareIcon>
		</span>
		<span class="theTag">
			<SchoolTag :schooldata="schooldata"></SchoolTag>
			<div style="margin-right: 5px;color: #999;padding-top: 5px; font-size: 14px;">{{ schooldata.ShengShi }}</div>
		</span>

	</span>
</template>

<script>
	import SchoolTag from './cp_school_tag.vue'
	
	export default {
		props: {
			IsFront: {
				type: Boolean,
				default: true,
				required: false,
			},
			schooldata: {
				type: Object,
				default: {},
				required: false,
			}
		},
		components: {
			SchoolTag
		},
		data() {
			return {

			}
		},
		computed: {
			isLogin() {
				let token = this.$store.getters.getToken();
				if (token == undefined || token.length <= 0)
					return false;
				return true;
			}
		},
		methods: {
			toSchoolSecond() {
				this.$emit("toParent");
			}
		},
		created() {
			
			
		},
		mounted() {
			
		}
	}
</script>

<style scoped="scoped">
	span {
		display: inline-block;
	}

	.school {
		position: relative;
		width: 100%;
		height: 100px;
		display: inline-block;
		cursor: pointer;
		margin-top: 10px;
		margin-bottom: 10px;
	}

	.school .el-image {
		width: 100px;
		height: 100px;
		position: absolute;
		top: 0px;
		left: 0px;
	}

	.name {
		position: absolute;
		top: 20px;
		left: 120px;
		height: 30px;
		font-size: 20px;
		font-weight: 600;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	/* .name>*:nth-child(1) {
		margin-right: 5px;
	} */

	.name>*:nth-child(n+1) {
		margin-right: 5px;
	}

	.theTag {
		position: absolute;
		top: 60px;
		left: 120px;
		height: 50px;
	}

	.name:hover .jieDu,
	.name:hover .compare {
		display: inline-block !important;
	}

	/* .compare {
		margin-top: 8px;
	} */
</style>